const AUTH_BASE = process.env.REACT_APP_URL_AUTH;
const PAY_BASE = process.env.REACT_APP_URL_PAYM;

function tokenHeaders() {
  const token = localStorage.getItem('token');
  return { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) };
}

async function json(res) {
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res.json();
}

export async function readAdminUsers() {
  return fetch(`${AUTH_BASE}/admin/users`, { headers: tokenHeaders() }).then(json);
}

export async function readAdminSubscriptions({ timeoutMs = 8000 } = {}) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    return await fetch(`${PAY_BASE}/admin/subscriptions`, {
      headers: tokenHeaders(),
      signal: controller.signal,
    }).then(json);
  } finally {
    clearTimeout(timer);
  }
}

export async function updateAdminUser(id, patch) {
  return fetch(`${AUTH_BASE}/admin/users/${id}`, {
    method: 'PATCH', headers: tokenHeaders(), body: JSON.stringify(patch)
  }).then(json);
}
